module.exports = __webpack_public_path__ + "static/img/hsf.2266133.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/testimonial-logos/hsf.png
// module id = bmzI
// module chunks = 0